import { loader } from 'graphql.macro'

export default function arDashboardMonthlyDataQuery ({ dataLoaders, queryKey }) {
  const [,
    filters = {},
    pager = null
  ] = queryKey

  let graphQLVariables = {
    filters
  }

  if (pager) {
    const paginatedVariables = {
      before: pager.direction === 'before' ? pager.cursor : null,
      after: pager.direction === 'after' ? pager.cursor : null,
      first: pager.direction === 'after' ? Number(pager.pageSize) : null,
      last: pager.direction === 'before' ? Number(pager.pageSize) : null
    }
    graphQLVariables = { ...graphQLVariables, ...paginatedVariables }
  }

  const arDashboardMonthlyDataSchema = loader('./arDashboardMonthlyData.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(arDashboardMonthlyDataSchema, graphQLVariables)
}
